import { ref } from 'vue';

export const GUIDE_PREVIEW_MAX = 3;

const activeScenarioId = ref('invoice');
const previewQuestion = ref('');
const previewContent = ref('');
const previewHistory = ref([]);
const previewLoading = ref(false);
const pendingAssistantPrompt = ref(null);
const guideClearTick = ref(0);

export function useJournalEntryGuide() {
  function setActiveScenario(id) {
    if (id) activeScenarioId.value = id;
  }

  function clearPreview() {
    previewHistory.value = [];
    previewQuestion.value = '';
    previewContent.value = '';
    previewLoading.value = false;
    pendingAssistantPrompt.value = null;
    guideClearTick.value += 1;
  }

  function appendPreviewEntry(question, content) {
    const q = typeof question === 'string' ? question.trim() : '';
    const c = typeof content === 'string' ? content : '';
    if (!c) return;

    previewHistory.value.push({
      id: `${Date.now()}-${previewHistory.value.length}`,
      question: q,
      content: c,
    });

    if (previewHistory.value.length > GUIDE_PREVIEW_MAX) {
      previewHistory.value = previewHistory.value.slice(-GUIDE_PREVIEW_MAX);
    }

    previewQuestion.value = q;
    previewContent.value = c;
  }

  function setPreviewLoading(loading) {
    previewLoading.value = !!loading;
  }

  function queueAssistantPrompt(prompt) {
    pendingAssistantPrompt.value = typeof prompt === 'string' ? prompt.trim() : '';
  }

  function consumeAssistantPrompt() {
    const p = pendingAssistantPrompt.value;
    pendingAssistantPrompt.value = null;
    return p;
  }

  return {
    activeScenarioId,
    previewQuestion,
    previewContent,
    previewHistory,
    previewLoading,
    pendingAssistantPrompt,
    guideClearTick,
    setActiveScenario,
    clearPreview,
    appendPreviewEntry,
    setPreviewLoading,
    queueAssistantPrompt,
    consumeAssistantPrompt,
  };
}
